module.exports = __webpack_public_path__ + "static/img/pjmr-1.83c7493.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/product/pjmr-1.png
// module id = 64zG
// module chunks = 15